/** HubSpot UI extension iframe modal close actions (openIframeModal). */
export type HubSpotIframeModalAction = "DONE" | "CANCEL";

/**
 * Closes an iframe opened via HubSpot's `openIframeModal` action.
 * @see https://developers.hubspot.com/docs/apps/developer-platform/add-features/ui-extensions/ui-extensions-sdk/actions
 */
export function closeHubSpotIframeModal(action: HubSpotIframeModalAction = "DONE") {
  const message = JSON.stringify({ action });
  const targets = [window.top, window.parent].filter(
    (target, index, arr): target is Window =>
      target != null && arr.indexOf(target) === index,
  );

  for (const target of targets) {
    try {
      target.postMessage(message, "*");
    } catch {
      /* noop */
    }
  }
}
